// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { JoHeader } from './jo-header';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ShipFrequency extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int16 */
  minDaysForNewBin?: number;
  /** String(50) */
  name!: string;
  /** String(2) */
  rRuleByWeekDay?: string;
  /** Inv FK shipFrequencyId */
  joHeaders!: JoHeader[];
}

